import { CheckboxTheme } from '@kite-js/theme-types';
import colors from '@theme/japanican/theme-japanican/colors';

const Checkbox: CheckboxTheme = {
    labelSpacing: 'S',
};

export default Checkbox;
